import Vue from 'vue';
import PresetSelector from './components/convert/PresetSelector';
import {PresetApi} from '../../../lib-sat/api/preset-api';
import {globalLogger} from '../../helper/global-logger';
import {userManager} from "../../../lib-sat/user/user-manager";

const $presetSelector = $('#qg-preset-selector');

(async () => {
    await import(
        /* webpackMode: "eager" */
        '../../../entrypoints/translations/sat-translations'
        );

    const user = await userManager.getUser();

    if ($presetSelector.length > 0 && !user.isAnonymous()) {
        const presetApi = new PresetApi();
        let presets = [];

        try {
            let response = await presetApi.getPersonalPresets();

            response = JSON.parse(response.data);

            response.forEach((preset) => {
                presets.push(preset);
            });

            new Vue({
                el: '#qg-preset-selector',
                name: 'PresetSelectorRoot',
                components: {
                    PresetSelector,
                },
                render(h) {
                    return h(PresetSelector, {props: {initialPresets: presets}});
                },
            });
        } catch (error) {
            globalLogger.log('preset-selector error:' + error.message);
        }
    }
})();
